/*
  Founder's Story — scroll-triggered reveals + subtle parallax.
  Vanilla JS, no dependencies. Respects prefers-reduced-motion by skipping
  parallax entirely and revealing content immediately (handled in CSS too,
  as a belt-and-braces fallback if JS fails to load).
*/
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var revealTargets = document.querySelectorAll('.founders-story .story-animate');

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    revealTargets.forEach(function (el) {
      el.classList.add('is-visible');
    });
  } else {
    var revealObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    revealTargets.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  if (prefersReducedMotion) return;

  var parallaxTargets = document.querySelectorAll('.founders-story [data-parallax]');
  if (!parallaxTargets.length) return;

  var ticking = false;

  function updateParallax() {
    var viewportHeight = window.innerHeight;

    parallaxTargets.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      // Progress: -1 (just below viewport) -> 1 (just above viewport), 0 = centered.
      var progress = (rect.top + rect.height / 2 - viewportHeight / 2) / (viewportHeight / 2 + rect.height / 2);
      var strength = parseFloat(el.getAttribute('data-parallax')) || 20;
      var offset = progress * strength;
      el.style.transform = 'translate3d(0, ' + offset.toFixed(2) + 'px, 0) scale(1.08)';
    });

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  updateParallax();
})();
